import { useNavigation } from '@react-navigation/native';
import { Image } from 'expo-image';
import { useSafeAreaInsets } from 'react-native-safe-area-context';

import { Button } from '@oui/app-core/src/components/Button';
import { ScrollView } from '@oui/app-core/src/components/ScrollView';
import { Heading, Text } from '@oui/app-core/src/components/Text';
import { View } from '@oui/app-core/src/components/View';
import { useWindowDimensions } from '@oui/app-core/src/hooks/useWindowDimensions';
import { useI18n } from '@oui/app-core/src/lib/i18n';

import { RootStackScreenProps } from '@src/types/navigation';

import FullLogo from '../assets/Full_logo.svg';
import WelcomeEnvelope from '../assets/welcome_envelope.svg';

export function Welcome(_props: {}) {
  const { $t } = useI18n();
  const { height } = useWindowDimensions();
  const navigation = useNavigation<RootStackScreenProps<'Welcome'>['navigation']>();
  const insets = useSafeAreaInsets();

  return (
    <View
      style={{
        flexGrow: 1,
        paddingBottom: insets.bottom,
      }}
    >
      <ScrollView
        contentContainerStyle={{
          paddingTop: insets.top,
          flex: 1,
        }}
      >
        <View
          flex={1}
          style={{
            marginTop: height < 600 ? 20 : 40,
          }}
        >
          <View
            flex={1}
            style={{
              alignItems: 'center',
            }}
          >
            <Image
              source={FullLogo}
              style={{
                height: height / 5,
                width: 200,
              }}
              contentFit="contain"
              contentPosition="center"
              aria-label={$t({
                id: 'Welcome_logoAccessibilityLabel',
                defaultMessage: 'Aviva Caregiver Logo',
              })}
            />

            <View
              style={{
                paddingHorizontal: 40,
              }}
              spacing={12}
            >
              <Heading
                level={1}
                text={$t({ id: 'Welcome_title', defaultMessage: 'Welcome to Aviva Caregiver' })}
                testID="Welcome_title"
                textAlign="center"
              />
              <Text
                text={$t({
                  id: 'Welcome_message',
                  defaultMessage:
                    'To activate your account, please contact your child’s clinician for a link',
                })}
                testID="Welcome_message"
                style={{ textAlign: 'center' }}
              />
            </View>
          </View>

          <Image
            source={WelcomeEnvelope}
            style={{
              height: height / 4,
              aspectRatio: 313 / 244,
              alignSelf: 'center',
            }}
          />
        </View>
      </ScrollView>
      <View>
        <View
          style={{
            borderTopWidth: 1,
          }}
        >
          <View style={{ padding: 16, alignItems: 'center' }} spacing={8}>
            <Button
              onPress={() => navigation.navigate('Login', {})}
              text={$t({
                id: 'Welcome_navigateToLogin',
                defaultMessage: 'I already have an account',
              })}
              testID="Welcome_navigateToLoginButton"
              variant="text"
              alignSelf="center"
            />
          </View>
        </View>
      </View>
    </View>
  );
}
